var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupConfIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 54,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "groupConfIcon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u9577\\u65B9\\u5F62 282",
    fill: "#a1a1a1",
    stroke: "#707070",
    d: "M0 0h54v54H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "groupConfIcon_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u9577\\u65B9\\u5F62 337",
    fill: "none",
    d: "M0 0h54v54H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "InCommsSettingIcon",
    clipPath: "url(#groupConfIcon_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 341",
    fill: "#040000",
    clipPath: "url(#groupConfIcon_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 357",
    d: "M16.412 16.786a1.122 1.122 0 110 1.586 1.122 1.122 0 010-1.586"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 358",
    d: "M16.555 4.835A11.621 11.621 0 004.507 16.884a.68.68 0 001.359-.048A10.261 10.261 0 0116.507 6.194a.68.68 0 10.048-1.359"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 359",
    d: "M16.775 8.586a8.32 8.32 0 00-8.518 8.518.68.68 0 101.36-.005 6.962 6.962 0 017.153-7.153.68.68 0 10.005-1.36"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 360",
    d: "M16.843 12.501a4.905 4.905 0 00-3.344 1.335l-.035.031a4.906 4.906 0 00-1.335 3.344.68.68 0 001.36.006 3.548 3.548 0 01.937-2.389l.035-.035a3.552 3.552 0 012.389-.937.68.68 0 10-.006-1.36"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 361",
    d: "M21.951 18.299v9.918a4.965 4.965 0 00-1.956-.4c-2.194 0-3.912 1.288-3.912 2.934s1.718 2.934 3.912 2.934 3.911-1.288 3.911-2.934v-7.022l7.823-1.565v4.093a4.963 4.963 0 00-1.956-.4c-2.194 0-3.911 1.288-3.911 2.934s1.718 2.934 3.911 2.934 3.911-1.288 3.911-2.934V15.952z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 362",
    d: "M21.951 35.639h-1.956a3.915 3.915 0 01-3.912 3.912v1.956a3.916 3.916 0 013.912 3.912h1.956a3.915 3.915 0 013.91-3.913V39.55a3.915 3.915 0 01-3.91-3.911"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 363",
    d: "M39.552 25.864h1.956a1.958 1.958 0 011.956-1.956v-1.959a1.958 1.958 0 01-1.956-1.956h-1.956a1.958 1.958 0 01-1.956 1.956v1.956a1.958 1.958 0 011.956 1.959"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u9577\\u65B9\\u5F62 334",
    d: "M25.862 33.683h1.955v1.956h-1.955z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u9577\\u65B9\\u5F62 335",
    d: "M29.773 37.595h1.956v1.956h-1.956z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u9577\\u65B9\\u5F62 336",
    d: "M35.641 25.861h1.956v1.956h-1.956z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 364",
    d: "M35.64 29.922v12.391a5.663 5.663 0 00-2.934-.8c-2.7 0-4.89 1.754-4.89 3.912s2.194 3.912 4.89 3.912 4.889-1.754 4.889-3.912v-7.97l9.91-1.642v4.54a5.662 5.662 0 00-2.934-.8c-2.7 0-4.889 1.754-4.889 3.912s2.19 3.909 4.89 3.909 4.889-1.754 4.889-3.911V27.64z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupConfIcon);
export default __webpack_public_path__ + "static/media/groupConfIcon.bde8dce00aa6975b.svg";
export { ForwardRef as ReactComponent };